import React, { useState } from 'react';
import { Grid, Paper, Avatar, TextField, Button, Typography } from '@material-ui/core'
import { useHistory } from "react-router-dom";
import axios from 'axios';
import "./LogSign.css"
import { bcAlert } from '../../boclAlert'

const ForgotPassword = () => {

    const paperStyle = { padding: 30, height: 'auto', width: 480, maxWidth: "90%", margin: "0 auto", paddingTop: '50px' }
    const avatarStyle = { backgroundColor: '#3370bd', width: 60, height: 60 }
    const btnstyle = { margin: '2rem 0' }

    const [correo, setCorreo] = useState("");
    const [errors, setErrors] = useState('');
    const [msgColor, setMsgColor] = useState('');
    let history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validar email
        if (correo === '' || !correo.includes("@") || !correo.includes(".")) {
            setErrors("El correo es inválido");
            setMsgColor("red")
            return false;
        }

        // SET LOADER
        let btnSend = document.querySelector("#btnSendEmail .MuiButton-label");
        let ogInner = btnSend.innerHTML;
        let loaderHtml = `<img class="loopLoader_blue boclLoader" src="${process.env.PUBLIC_URL}/svg/loopLoader.svg"></img>`;
        btnSend.innerHTML = loaderHtml;

        // Preparar datos como FormData (no JSON)
        let formData = new FormData();
        formData.append('email', correo);

        // Hacer POST
        axios.post(process.env.REACT_APP_API_DM_URL + "/password/email", formData)
            .then(response => {
                btnSend.innerHTML = ogInner;

                if (response.data.status === "success") {
                    setErrors("Se ha enviado un enlace a tu correo");
                    setMsgColor("green")
                    setCorreo("");

                    bcAlert({
                        msg: {
                            "title": "¡Listo!",
                            "desc": "Se ha enviado un enlace de recuperación a tu correo."
                        },
                        type: "success",
                        styles: ``,
                        options: false
                    });

                    setTimeout(() => {
                        history.push("/");
                    }, 2000);
                } else if (response.data.status === "error_duplicado") {
                    setErrors("Ya se envió un código a este correo. Revisa tu bandeja de entrada o spam");
                    setMsgColor("darkorange")
                    
                    bcAlert({
                        msg: {
                            "title": "Intenta más tarde",
                            "desc": "Ya se envió un código a este correo. Verifica tu bandeja de entrada o spam."
                        },
                        type: "warning",
                        styles: ``,
                        options: false
                    });
                } else {
                    setErrors("Ocurrió un error. Intenta de nuevo");
                    setMsgColor("red")
                    
                    bcAlert({
                        msg: {
                            "title": "Error",
                            "desc": "Ocurrió un problema inesperado al enviar el correo. Intenta de nuevo."
                        },
                        type: "warning",
                        styles: ``,
                        options: false
                    });
                }
            })
            .catch(function (error) {
                btnSend.innerHTML = ogInner;
                console.log('Error:', error);
                
                // Si es 422, el correo se envió de todas formas
                if (error.response && error.response.status === 422) {
                    setErrors("Se ha enviado un enlace a tu correo")
                    setMsgColor("green")
                    setCorreo("");

                    bcAlert({
                        msg: {
                            "title": "¡Listo!",
                            "desc": "Se ha enviado un enlace de recuperación a tu correo."
                        },
                        type: "success",
                        styles: ``,
                        options: false
                    });

                    setTimeout(() => {
                        history.push("/");
                    }, 2000);
                } else if (error.response) {
                    // Hay respuesta del servidor pero con error
                    setErrors(`Error ${error.response.status}: ${error.response.data?.message || 'Intenta de nuevo'}`)
                    setMsgColor("red")
                    
                    bcAlert({
                        msg: {
                            "title": "Error del servidor",
                            "desc": error.response.data?.message || "Ocurrió un error. Intenta más tarde."
                        },
                        type: "warning",
                        styles: ``,
                        options: false
                    });
                } else {
                    // No hay respuesta del servidor (problema de conexión)
                    // Mostrar éxito de todas formas (como hace la app móvil)
                    setErrors("Se ha enviado un enlace a tu correo")
                    setMsgColor("green")
                    setCorreo("");
                    
                    bcAlert({
                        msg: {
                            "title": "¡Listo!",
                            "desc": "Se ha enviado un enlace de recuperación a tu correo."
                        },
                        type: "success",
                        styles: ``,
                        options: false
                    });

                    setTimeout(() => {
                        history.push("/");
                    }, 2000);
                }
            });
    }

    return (
        <Grid className="section-logsign">
            <form onSubmit={handleSubmit}>
                <Paper elevation={10} style={paperStyle}>
                    <Grid align='center'>
                        <Avatar style={avatarStyle}>
                            <img src={`images/isotipo_black.svg`} alt={"iso"} style={{ width: "40px", filter: "invert(1)" }} />
                        </Avatar>
                        <h2 style={{ marginTop: "1rem" }}>Recuperar Contraseña</h2>
                        <h3 style={{ color: msgColor, margin: ".8rem 0 1rem 0" }}>{errors}</h3>
                    </Grid>

                    <TextField
                        label='Email'
                        className="login-input"
                        name="correo"
                        value={correo}
                        onChange={(e) => setCorreo(e.target.value)}
                        placeholder='Ingresa tu correo'
                        type='email'
                        fullWidth
                        required
                    />

                    <p style={{ fontSize: '0.85rem', color: '#666', margin: "0.5rem 0" }}>
                        Te enviaremos un enlace para restablecer tu contraseña
                    </p>

                    <Button type='submit' id="btnSendEmail" color='primary' variant="contained" style={btnstyle} fullWidth>
                        Enviar Enlace
                    </Button>

                    <Typography align="center">
                        <a href="/" style={{ color: '#3370bd', textDecoration: 'none', cursor: 'pointer' }}>
                            Volver al inicio de sesión
                        </a>
                    </Typography>
                </Paper>
            </form>
        </Grid>
    )
}

export default ForgotPassword
